import styled from '@emotion/styled';
import { Colors } from '@zapier/design-system';
import { RichTextHTMLString } from '../sections/types';

type Props = {
  html: RichTextHTMLString;
  isDarkBackground?: boolean;
};

/**
 * A naive "render rich text" solution until we dig in further in https://zapierorg.atlassian.net/browse/ATC-1173
 * Accepts props.html as a string of HTML
 * Currently renders naively as dangerouslySetInnerHTML
 */
export function RichTextHtml(props: Props) {
  return (
    <RichText
      dangerouslySetInnerHTML={{ __html: props.html }}
      isDarkBackground={props.isDarkBackground}
    />
  );
}
type RichTextProps = {
  isDarkBackground?: boolean;
};

function getLinkColor({ isDarkBackground }: RichTextProps) {
  if (isDarkBackground) {
    return 'inherit';
  }

  return Colors.blue;
}

function getLinkHoverColor({ isDarkBackground }: RichTextProps) {
  if (isDarkBackground) {
    return 'inherit';
  }

  return Colors.night;
}

const RichText = styled.div`
  a {
    color: ${getLinkColor};
    text-decoration: underline;

    &:hover {
      color: ${getLinkHoverColor};
      text-decoration: underline;
    }
  }

  ul {
    list-style: none;
    margin-left: 32px;

    li {
      position: relative;

      &:before {
        content: '•';
        font-weight: bold;
        display: flex;
        align-items: baseline;
        position: absolute;
        font-size: 16px;
        margin-left: -1em;
        height: 100%;
      }

      &:not(:last-child) {
        margin: 21px 0;
      }
    }
  }

  ol {
    list-style: none;
    margin-left: 32px;

    li {
      counter-reset: list-1 list-2;
      counter-increment: list-0;

      &:not(:last-child) {
        margin: 21px 0;
      }

      &:before {
        content: counter(list-0, decimal) '. ';
        margin-left: -1em;
      }

      &.ql-indent-1 {
        counter-increment: list-1;
        counter-reset: list-2;

        &:before {
          content: counter(list-1, lower-alpha) '. ';
        }
      }

      &.ql-indent-2 {
        counter-increment: list-2;
        counter-reset: none;

        &:before {
          content: counter(list-2, lower-roman) '. ';
        }
      }
    }
  }

  li.ql-indent-1 {
    padding-left: 2em;
  }

  li.ql-indent-2 {
    padding-left: 4em;
  }

  p:not(:first-of-type) {
    margin-top: 10px;
  }
`;
